import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { FaApple, FaBowlFood, FaBriefcase, FaBurger, FaCartShopping, FaFire, FaGooglePlay, FaIceCream, FaKitchenSet, FaLocationDot, FaMapLocationDot, FaPizzaSlice, FaStar, FaStore, FaTemperatureHigh, FaTrophy, FaUsers, FaUtensils } from "react-icons/fa6";
import "../AllRider/allRider.css";
import "../style01.css";
import "../style02.css";
import "./metuaaEat.css";
import eatPhoto from "../../../assets/images/eat2.jpg";
import phoneImage from "../../../assets/metuaa-eats-image.png";
import metuaaEatImage from "../../../assets/images/metuaa-eat.png";
import Slide_image_metuaa_eat from "../../../assets/images/all-slider/image-metuaa-eat.png";
import dish1 from "../../../assets/images/repas1.png";
import dish2 from "../../../assets/images/repas2.png";
import dish3 from "../../../assets/images/repas3.png";
import dish4 from "../../../assets/images/repas4.png";
import dish5 from "../../../assets/images/repas5.jpg";
import offer_1 from "../../../assets/images/offer_1.png";
import offer_2 from "../../../assets/images/offer_2.png";
import Header from "../../../components/header";
import Footer from "../../../components/footer";

const foodFilters = [
  { id: "all", label: "Tout afficher", icon: FaStar },
  { id: "terroir", label: "Terroir Kmer & Ndolé", icon: FaBowlFood },
  { id: "grillades", label: "Braises & Grillades", icon: FaFire },
  { id: "fast-food", label: "Fast-Food & Burgers", icon: FaBurger },
  { id: "pizzas", label: "Pizzas", icon: FaPizzaSlice },
  { id: "corporate", label: "Menus Midi Corporate", icon: FaBriefcase },
  { id: "desserts", label: "Desserts & Sucré", icon: FaIceCream },
];

const topPartners = [
  { key: "dish1", image: dish1 },
  { key: "dish2", image: dish2 },
  { key: "dish3", image: dish3 },
  { key: "dish4", image: dish4 },
  { key: "dish5", image: dish5 },
  { name: "Metua'a Eat", image: eatPhoto },
  { name: "Metua'a Eat", image: metuaaEatImage },
  { name: "Metua'a Eat", image: Slide_image_metuaa_eat },
];

const dishes = [
  { image: dish1, key: "dish1" },
  { image: dish2, key: "dish2" },
  { image: dish3, key: "dish3" },
  { image: dish4, key: "dish4" },
  { image: dish5, key: "dish5" },
];

const heroSlides = [
  {
    webp: Slide_image_metuaa_eat,
    src: Slide_image_metuaa_eat,
    alt: "Plats et marchés livrés par Metua'a Eats",
    title1Id: "eats.slide1.title1",
    title2Id: "eats.slide1.title2",
    descriptionId: "eats.slide1.description",
    ctaHref: "/signup-passenger",
  },
];

const heroTransitionTypes = ["fade", "slide-left", "slide-right", "square"];

const howItWorksSteps = [
  {
    key: "location",
    icon: FaLocationDot,
    title: "Indiquez-nous où vous êtes",
    text: "Nous vous indiquerons les partenaires à proximité chez qui vous pouvez commander.",
  },
  {
    key: "find",
    icon: FaUtensils,
    title: "Trouvez ce dont vous avez envie",
    text: "Cherchez par article ou repas, par partenaire ou type de cuisine.",
  },
  {
    key: "order",
    icon: FaCartShopping,
    title: "Commandez à livrer ou à emporter",
    text: "Nous vous tiendrons au courant du déroulement de votre commande.",
  },
];

export const featureCards = [
  {
    key: "chefs",
    icon: FaKitchenSet,
    title: "Sélection des meilleurs Chefs",
    text: "Du grand restaurant d'Akwa au tourne-dos réputé de votre quartier, accédez à des plats cuisinés de confiance.",
  },
  {
    key: "isotherm",
    icon: FaTemperatureHigh,
    title: "Garantie Isotherme & Scellés",
    text: "Nos livreurs utilisent des caissons étanches renforcés. Votre poulet ou poisson braisé arrive à la température idéale.",
  },
  {
    key: "gps",
    icon: FaMapLocationDot,
    title: "Suivi GPS en temps réel",
    text: "Regardez votre repas faire son trajet en direct sur la carte, de la cuisine du restaurant jusqu'à votre table.",
  },
  {
    key: "ranking",
    icon: FaTrophy,
    title: "Classement Kmer's Chef",
    text: "Votez pour vos restaurants favoris et gagnez des points de fidélité transformables en repas gratuits.",
  },
];

function ChevronLeftIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
      <path d="m12.843 25.836 1.585-1.608L7.32 17.12H29v-2.256H7.321l7.107-7.13-1.585-1.585L3 15.993l9.843 9.843z" />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
      <path d="m19.157 6.15-1.584 1.608 7.106 7.107H3v2.256h21.679l-7.106 7.13 1.584 1.585L29 15.993 19.157 6.15z" />
    </svg>
  );
}

const IconArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M9.652 2.65 8.426 3.876l3.258 3.258H1v1.728h10.684L8.426 12.12l1.226 1.226L15 7.998 9.652 2.65z" />
  </svg>
);

export default function AllMetuaaEat() {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const [heroIndex, setHeroIndex] = useState(0);
  const [heroPrevIndex, setHeroPrevIndex] = useState(0);
  const [heroTransition, setHeroTransition] = useState("fade");
  const [isHeroPaused, setIsHeroPaused] = useState(false);
  const [activeFoodFilter, setActiveFoodFilter] = useState("all");
  const heroTimerRef = useRef(null);

  const goToHeroSlide = (updater) => {
    const type = heroTransitionTypes[Math.floor(Math.random() * heroTransitionTypes.length)];
    setHeroTransition(type);
    setHeroIndex(updater);
  };

  useEffect(() => {
    if (isHeroPaused || heroSlides.length <= 1) return;
    heroTimerRef.current = setInterval(() => {
      goToHeroSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(heroTimerRef.current);
  }, [isHeroPaused]);

  useEffect(() => {
    if (heroPrevIndex === heroIndex) return;
    const id = setTimeout(() => setHeroPrevIndex(heroIndex), 900);
    return () => clearTimeout(id);
  }, [heroIndex, heroPrevIndex]);

  const hasMultipleSlides = heroSlides.length > 1;

  return (
    <div id="__next">
      <div className="sc-19804fb5-0 fKeZVt">
        <span data-testid="core-ui-theme-provider" className="sc-dGCmGc kFXgow">
          <span data-testid="core-ui-theme-provider" className="sc-dGCmGc cukWQg">
            <Header />

            <main className="metuaa-eat-page">
            

              {/* ══════════════════ HERO SLIDE ══════════════════ */}
              <section
                data-testid="eats-hero-slider"
                className="eats-slider"
                onMouseEnter={() => setIsHeroPaused(true)}
                onMouseLeave={() => setIsHeroPaused(false)}
              >
                <picture className="eats-slider__layer">
                  <source type="image/webp" srcSet={heroSlides[heroPrevIndex].webp} />
                  <img src={heroSlides[heroPrevIndex].src} alt={heroSlides[heroPrevIndex].alt} />
                </picture>

                {heroIndex !== heroPrevIndex && (
                  <picture key={heroIndex} className={`eats-slider__layer eats-slider__anim hero-anim-${heroTransition}`}>
                    <source type="image/webp" srcSet={heroSlides[heroIndex]?.webp} />
                    <img src={heroSlides[heroIndex]?.src} alt={heroSlides[heroIndex]?.alt} />
                  </picture>
                )}

                <div className="eats-slider__overlay" aria-hidden="true" />

                <div className="eats-slider__content">
                  <div key={heroIndex} className={`hero-slide-anim hero-anim-${heroTransition}`}>
                    <h1 className="eats-slider__title">
                      {t(heroSlides[heroIndex]?.title1Id)}{" "}
                      <span>{t(heroSlides[heroIndex]?.title2Id)}</span>
                    </h1>
                    <p className="eats-slider__desc">{t(heroSlides[heroIndex]?.descriptionId)}</p>
                    <div className="eats-slider__search">
                      <span className="eats-slider__search-icon">
                        <FaLocationDot />
                      </span>
                      <input
                        type="text"
                        placeholder={t("eats.slide1.search.placeholder")}
                      />
                      <button type="button">{t("eats.slide1.search.button")}</button>
                    </div>
                    <div className="hero-btn-group">
                      <a href="#" className="btn-secondary-outline">{t("eats.slide1.partner")}</a>
                    </div>
                  </div>
                </div>

                {hasMultipleSlides && (
                  <>
                    <button
                      type="button"
                      className="eats-slider__arrow eats-slider__arrow--prev"
                      aria-label={t("eats.slide.prev")}
                      onClick={() => goToHeroSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
                    >
                      <ChevronLeftIcon />
                    </button>
                    <button
                      type="button"
                      className="eats-slider__arrow eats-slider__arrow--next"
                      aria-label={t("eats.slide.next")}
                      onClick={() => goToHeroSlide((prev) => (prev + 1) % heroSlides.length)}
                    >
                      <ChevronRightIcon />
                    </button>
                    <div className="eats-slider__dots">
                      {heroSlides.map((_, i) => (
                        <button
                          key={i}
                          type="button"
                          aria-label={t("eats.slide.dot", { index: i + 1 })}
                          className={`eats-slider__dot${i === heroIndex ? " is-active" : ""}`}
                          onClick={() => goToHeroSlide(() => i)}
                        />
                      ))}
                    </div>
                  </>
                )}
              </section>

              {/* ══════════════════ FOOD FILTERS ══════════════════ */}
              <section className="food-filters-section" aria-label="Filtres de catégories">
                <div className="filters-scroll">
                  {foodFilters.map(({ id, label, icon: Icon }) => (
                    <button
                      key={id}
                      type="button"
                      className={`filter-chip${activeFoodFilter === id ? " active" : ""}`}
                      aria-pressed={activeFoodFilter === id}
                      onClick={() => setActiveFoodFilter(id)}
                    >
                      <Icon aria-hidden="true" />
                      {label}
                    </button>
                  ))}
                </div>
              </section>

              {/* ══════════════════ TOP PARTNERS ══════════════════ */}
              <section className="top-partners-section" aria-labelledby="top-partners-title">
                <div className="page-shell">
                  <h2 id="top-partners-title" className="top-partners-title">
                    Metua'a Eats : <mark>Meilleurs restaurants et plus</mark>
                  </h2>
                  <div className="top-partners-grid">
                    {topPartners.map((partner) => {
                      const name = partner.key ? t(`eats.dishes.${partner.key}.name`) : partner.name;
                      return (
                        <article key={`${partner.key || partner.name}-${partner.image}`} className="top-partner-card">
                          <div className="top-partner-image">
                            <img src={partner.image} alt={name} loading="lazy" decoding="async" />
                          </div>
                          <span className="top-partner-name">{name}</span>
                        </article>
                      );
                    })}
                  </div>
                </div>
              </section>

  {/* ══════════════════ HOW IT WORKS ══════════════════ */}
              <section className="how-it-works-section" data-qa="how-it-works-section">
                <div className="how-it-works-content">
                  <h3 className="how-it-works-eyebrow">Comment ça marche ???</h3>
                  <h2 className="how-it-works-title">Simple et rapide !</h2>
                  <div className="how-it-works-grid">
                    {howItWorksSteps.map((step) => (
                      <article key={step.key} className="how-it-works-card">
                        <step.icon aria-hidden="true" className="how-it-works-icon" />
                        <h5 className="how-it-works-card-title">{step.title}</h5>
                        <p className="how-it-works-card-text">{step.text}</p>
                      </article>
                    ))}
                  </div>
                </div>
              </section>

              {/* ══════════════════ CORPORATE BANNER ══════════════════ */}
              <section className="corporate-section">
                <h1 className="corporate-title">Commande Groupée Entreprise</h1>
                <section className="corporate-banner">
                  
                  <div className="corporate-text">
                    <h2>
                      Midi au Bureau ? <span>Commandez Groupé !</span>
                    </h2>
                    <p>
                      Partagez un lien unique avec vos collègues à Akwa, Bali ou Bonanjo. Ajoutez chacun vos plats favoris et
                      groupez votre commande pour effacer les frais de livraison individuels.
                    </p>
                  </div>
                  <div className="corporate-action">
                    <button type="button">
                      <FaUsers aria-hidden="true" /> Lancer un groupe
                    </button>
                  </div>
                </section>
              </section>
              


              {/* ══════════════════ FEATURE CARDS ══════════════════ */}
              <section className="feature-cards-section">
                <div className="page-shell">
                  <h2 className="feature-cards-title">Vos plats préférés, livrés intacts et fumants</h2>
                  <div className="feature-cards-grid">
                    {featureCards.map((card) => (
                      <article key={card.key} className="feature-card">
                        <card.icon aria-hidden="true" className="feature-card-icon" />
                        <h3>{card.title}</h3>
                        <p>{card.text}</p>
                      </article>
                    ))}
                  </div>
                </div>
              </section>

              {/* ══════════════════ OFFERS ══════════════════ */}
              <section
                className="all-page-section sc-cd975d71-0 fJfYVy sc-4d039203-0 iaLMvL"
                data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Up"
                data-tracking-action="view"
                data-tracking-category="TextImageModule"
              >
                <div className="sc-eNSrOW kusvag">
                  <div
                    className="sc-satoz iYojpr"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      gap: "24px",
                      width: "100%",
                    }}
                  >
                    {/* Colonne 1 : Card Package Famille */}
                    <div className="offer-card-col">
                      <div className="cardOffer" style={{ backgroundImage: `url(${offer_1})` }}>
                        <div className="cardOffer-overlay">
                          <p className="cardOffer-label">{t("home.offers.family.label")}</p>
                          <h3 className="cardOffer-title">{t("home.offers.family.title")}</h3>
                          <div className="cardOffer-code">
                            <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                            <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                          </div>
                          <button className="cardOffer-button">
                            {t("home.offers.discover")}
                            <IconArrowRight />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Colonne 2 : Card Package Entreprise */}
                    <div className="offer-card-col">
                      <div className="cardOffer" style={{ backgroundImage: `url(${offer_2})` }}>
                        <div className="cardOffer-overlay">
                          <p className="cardOffer-label">{t("home.offers.business.label")}</p>
                          <h3 className="cardOffer-title">{t("home.offers.business.title")}</h3>
                          <div className="cardOffer-code">
                            <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                            <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                          </div>
                          <button type="button" className="cardOffer-button">
                            <span>{t("home.offers.discover")}</span>
                            <IconArrowRight />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* ══════════════════ DOWNLOAD APP ══════════════════ */}
              <section className="download-app-section" data-qa="download-app-section">
                <div className="page-shell">
                  <div className="download-app-layout">
                    <div className="download-app-info">
                      <h3 className="download-app-title">Téléchargez l'application</h3>
                      <p className="download-app-subtitle">Commandez où que vous soyez !</p>
                      <div className="download-app-stores">
                        <a className="store-badge" href="#" aria-label="Accéder à iOS App Store" data-qa="download-app-section-ios-link">
                          <FaApple aria-hidden="true" />
                          <span>App Store</span>
                        </a>
                        <a className="store-badge" href="#" aria-label="Accéder à Google Play Store" data-qa="download-app-section-android-link">
                          <FaGooglePlay aria-hidden="true" />
                          <span>Google Play</span>
                        </a>
                       
                      </div>
                    </div>
                    <div className="download-app-visual">
                      <img src={phoneImage} alt="Aperçu de l'application Metua'a Eat" loading="lazy" decoding="async" />
                    </div>
                  </div>
                </div>
              </section>

              
            </main>

            <Footer />
          </span>
        </span>
      </div>
    </div>
  );
}
